import { Controller, useFormContext } from 'react-hook-form';
import { IonicInput } from 'ionic-ui';
import { WalletIndividualKyc } from '../../../../../../../schemas/wallet-individual-kyc-schema';
import { Disco_Code_Options } from '../../../../../../../data/walletSetup/storeDirectorInfo';

type Props = {
  addresses: {
    value: number;
    label: string;
    disabled: boolean;
  }[];
};

export default function IndividualAddressVerificationDialog({
  addresses,
}: Props) {
  const { control } = useFormContext<WalletIndividualKyc>();

  return (
    <div>
      <h6 className="medium-emphasis-text font-medium">Verify your address</h6>
      <p className="medium-emphasis-text py-2">
        This step is optional, only fill if you want a tier three account.
      </p>

      <div className="py-4 space-y-4">
        <Controller
          control={control}
          name="savedAddressId"
          render={({ field, fieldState }) => (
            <IonicInput
              {...field}
              type="select"
              ignorePortal={true}
              options={addresses}
              label="wallet address*"
              placeholder="Select wallet address"
              hint={fieldState.error?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
        <Controller
          control={control}
          name="meter_number"
          render={({ field, fieldState }) => (
            <IonicInput
              {...field}
              type="text"
              label="Meter number*"
              placeholder="Select address"
              hint={fieldState.error?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
        <Controller
          control={control}
          name="disco_code"
          render={({ field, fieldState }) => (
            <IonicInput
              {...field}
              type="select"
              options={Disco_Code_Options}
              ignorePortal={true}
              label="DISCO code*"
              placeholder="Select address"
              hint={fieldState.error?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
      </div>
    </div>
  );
}
